import { useMutation, useQuery } from '@tanstack/react-query';
import { CreditNoteSettingsAPI } from 'api/credit-note-settings';
import { GENERAL_API_STALE } from 'config/query-config';
export const CREDIT_NOTE_SETTINGS_QUERY_KEY = [
    'credit-note-essential-settings'
];
export const CREDIT_NOTE_REASONS_QUERY_KEY = [
    'credit-note-reasons'
];
export const useCreditNoteEssentialSettingsQuery = (queryOptions = {})=>useQuery(CREDIT_NOTE_SETTINGS_QUERY_KEY, ()=>CreditNoteSettingsAPI.getSettingsConfiguration(), {
        staleTime: GENERAL_API_STALE,
        ...queryOptions
    });
export const useUpdateCreditNoteEssentialSettingMutation = ()=>{
    return useMutation(({ payload })=>CreditNoteSettingsAPI.updateSettingsConfiguration(payload));
};
export const useGetCreditNoteReasonsQuery = (queryOptions = {})=>useQuery(CREDIT_NOTE_REASONS_QUERY_KEY, ()=>CreditNoteSettingsAPI.getCreditNoteReasons(), {
        staleTime: GENERAL_API_STALE,
        ...queryOptions
    });
export const useCreateCreditNoteReasonMutation = ()=>{
    return useMutation((payload)=>CreditNoteSettingsAPI.createCreditNoteReason(payload));
};
export const useUpdateCreditNoteReasonMutation = ()=>{
    return useMutation(({ reasonId, payload })=>CreditNoteSettingsAPI.updateCreditNoteReason(reasonId, payload));
};
export const useDeleteCreditNoteReasonMutation = ()=>{
    return useMutation((reasonId)=>CreditNoteSettingsAPI.deleteCreditNoteReason(reasonId));
};
